import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PublicLayout = ({ children }) => (
  <div className="main-wrapper">
    <Header />
    <main style={{ position: 'relative' }}>
      {children}
    </main>
    <Footer />
  </div>
);

export default React.memo(PublicLayout);
